<template>
	<div>
		<div class="page-filter-box">
			 <el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="14" :lg="12" :xl="8">
					 <el-date-picker v-model="datetimerange" type="datetimerange" range-separator="至"
						 value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
						 start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels size="small">
					 </el-date-picker>
				</el-col>			 
				 <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					 <el-button type="primary" icon="el-icon-search" @click="getDetailData" size="small" :loading="dataLoading">查询</el-button>
					 <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				 </el-col>
			 </el-row>
		</div>
		<div v-loading="dataLoading">        
			<el-card class="MT20" v-if="data">
				<div slot="header">
					<span>立减订单汇总数据</span>				
				</div>
				<template>
					<el-row :gutter="20">
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">下单总人数: </span>{{data.userNum}}
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">下单总金额: </span>{{data.totalAmount}}			
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">总订单数: </span>{{data.orderNum}}	
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">立减优惠总金额: </span>{{ data.rdmDisAmount }} 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">立减最高金额: </span>{{ data.rdmMaxAmount }} 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">立减暴击订单数: </span>{{ data.critOrderNum }} 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">立减订单暴击率: </span>{{ data.critRatio }} 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info"> 下单新用户数: </span>{{data.newUserNum}}			
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">新用户下单订单数:  </span>{{data.newUserOrderNum}}		 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">新用户下单金额:  </span>{{data.newUserTotalAmount}}		 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">新用户立减优惠金额:  </span>{{data.newUserRdmDisAmount}}		 
						</el-col>
					</el-row>
				</template>
			</el-card>
			<el-card class="MT20" v-if="data">
				<div slot="header">
					<span>非立减订单汇总数据</span>				
				</div>
				<template>
					<el-row :gutter="20">
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">下单总人数: </span>{{data.nonRdmUserNum}}
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">下单总金额: </span>{{data.nonRdmTotalAmount}}			
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">总订单数: </span>{{data.nonRdmOrderNum}}	
						</el-col>				   
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info"> 下单新用户数: </span>{{data.nonRdmNewUserNum}}			
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">新用户下单订单数:  </span>{{data.nonRdmNewUserOrderNum}}		 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">新用户下单金额:  </span>{{data.nonRdmNewUserTotalAmount}}		 
						</el-col>					
					</el-row>
				</template>
			</el-card>
			<el-card class="MT20" v-if="data">
				<div slot="header">
					<span>活动演出聚合页</span>				
				</div>
				<template>
					<el-row :gutter="20">
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">PV: </span>{{data.aggPagePv}}
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">UV: </span>{{data.aggPageUv}}			
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">通过活动聚合页下单人数: </span>{{data.aggPageUserNum}}	
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
						   <span class="color-info">通过活动聚合页下单订单数: </span>{{ data.aggPageOrderNum }} 
						</el-col>
						<el-col :sm="12" :md="8" class="MT10">
							<span class="color-info">通过活动聚合页下单金额: </span>{{data.aggPageTotalAmount}}			
						</el-col>				   
					</el-row>
				</template>
			</el-card>
			<el-card class="MT20" v-if="data && data.detailList && data.detailList.length > 0 ">
				<div slot="header">
					<span>立减演出数据<small><span class="color-warning ML20">(根据下单金额从高到低取前50)</span></small></span>
					<el-button size="small" type="primary" :loading="uploadLoading" @click="uploadAll">导出完整数据</el-button>
				</div>		    
				<div class="page-list-box">
					<el-table
						:data="data.detailList"
						border
						style="width: 100%"
						v-loading="listLoading"
						size="small"
						stripe
					>
						<el-table-column prop="activityId" label="演出id"></el-table-column>  
						<el-table-column prop="activityName" label="演出名称"></el-table-column>  
						<el-table-column prop="orderUserNum" label="下单总人数"></el-table-column>  
						<el-table-column prop="orderNum" label="立减订单数"></el-table-column>  
						<el-table-column prop="totalAmount" label="下单总金额"></el-table-column>  
						<el-table-column prop="rdmDisAmount" label="立减优惠总金额"></el-table-column>  
					</el-table>
				</div>		   
			</el-card>
			<el-card class="MT20" v-if="data && data.critOrderDetailList && data.critOrderDetailList.length > 0">
				<div slot="header">
					<span>立减暴击订单明细</span>
					<el-button size="small" type="primary" :loading="critExportLoading" @click="exportCritOrder">导出订单</el-button>
				</div>
				<div class="page-list-box">
					<el-table
						:data="data.critOrderDetailList"
						border
						style="width: 100%"
						v-loading="listLoading"
						size="small"
						stripe
					>
						<el-table-column prop="orderSn" label="订单编号" show-overflow-tooltip></el-table-column>
						<el-table-column prop="activityId" label="演出ID" show-overflow-tooltip></el-table-column>
						<el-table-column prop="goodsName" label="票品名称" show-overflow-tooltip></el-table-column>
						<el-table-column prop="goodsPrice" label="票品金额" show-overflow-tooltip></el-table-column>
						<el-table-column prop="userId" label="用户ID" show-overflow-tooltip></el-table-column>
						<el-table-column prop="userPhone" label="用户手机号" show-overflow-tooltip></el-table-column>
						<el-table-column prop="totalAmount" label="订单金额" show-overflow-tooltip></el-table-column>
						<el-table-column prop="critAmount" label="暴击金额" show-overflow-tooltip></el-table-column>
						<el-table-column prop="createTime" label="下单时间" show-overflow-tooltip></el-table-column>
					</el-table>
				</div>
			</el-card>
			<div class="page-btns-box MT20">			
				<el-button @click="goBack()" >返 回</el-button>
			</div>
    </div>
	</div>
</template>
<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        },
		time: {
		    type: [Number, String],
		    default: ""
		}
    },
    components:{
        
    },
    data() {
		const routeEndTime = this.$route.query.endTime || '';
		const nowTime = this.$utils.formatDate(new Date().getTime() - 3600 * 1000 * 24, 'yyyy-MM-dd HH:mm:ss');
		const endTimeVal = routeEndTime && new Date(routeEndTime).getTime() < new Date().getTime() ? routeEndTime : nowTime;
        return {
            data: null,
            dataLoading: false,
            
            userData:null,
            userList: [],
           
            downLoading: false,
			
			redirect: this.$route.query.redirect || '',
			
			uploadLoading:false,

			critExportLoading: false,

			listLoading:false,

			endTime: routeEndTime,
			
			datetimerange: [this.time || '', endTimeVal],
        }
    },
   
    mounted() {
        if (this.id) {
			
            this.getDetailData();
            
        }
    },
    methods: {
		
		//返回
		goBack() {
		    if (this.redirect) {
		        this.$router.push({
		            path: this.redirect,
		        });
		    } else {
		        this.$router.go(-1);
		    }
		},
        //获取详情
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/random/discount/statistics",
                method: "POST",
                data: {
                    id: this.id,
					startTime:this.datetimerange[0],
					endTime:this.datetimerange[1]
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		
		//重置搜索
		reset() {
			const yesterday = this.$utils.formatDate(new Date().getTime() - 3600 * 1000 * 24, 'yyyy-MM-dd HH:mm:ss');
			const endTimeVal = this.endTime && new Date(this.endTime).getTime() < new Date().getTime() ? this.endTime : yesterday;
			this.datetimerange = [this.time || '', endTimeVal];
			this.getDetailData();
		},
		async uploadAll(){
		    let filePath;
		    this.uploadLoading = true;
		    const res = await this.$request({
		        url:'/random/discount/export',
		        method: 'post',
				params: {
				    id: this.id
				},
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result:{url}} = res.data;
		    if(state == 1 &&  url){
		        filePath = url;
		    }else{
		        this.uploadLoading = false;
		        return this.$message.error(msg || '下载失败');
		    }   
		
		    await downloadFileTmp(filePath,'立减活动'+ this.id + '演出明细.'+this.$utils.getFileType(filePath));
		    this.uploadLoading = false;
		},
		// 导出暴击订单
		async exportCritOrder() {
		    this.critExportLoading = true;
		    const res = await this.$request({
		        url: '/random/discount/exportCritOrderDetail',
		        method: 'post',
		        params: {
		            id: this.id,
		            startTime: this.datetimerange[0],
		            endTime: this.datetimerange[1]
		        },
		    }).catch(err => {
		        this.$message({ message: err.message, type: 'error' });
		    });
		    const { state, msg, result: { url, fileName } } = res.data;
		    if (state == 1 && url) {
				const _fileName = fileName ? fileName : `立减活动${this.id}暴击订单明细`;
		        await downloadFileTmp(url, (_fileName + '.') + this.$utils.getFileType(url));
		    } else {
		        this.$message.error(msg || '下载失败');
		    }
		    this.critExportLoading = false;
		},		
    }
}
</script>
<style lang="scss" scoped>
.el-card__header {
    >div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-button--text {
            padding: 0;
            font-size: 12px;
        }
    }
}
</style>